import { useContext, useState } from 'react';
import { useCookies } from 'react-cookie';

import { IdContext } from '../../context';

export function useClient() {
  const {
    redirectURL,
    tenancy,
    product,
    clientState,
    sessionMfaKey,
    useCookieStorage,
  } = useContext(IdContext);

  const [cookies, setCookie] = useCookies([sessionMfaKey]);

  const isBrowser = typeof window !== 'undefined';
  const getMfaToken = () => {
    if (useCookieStorage) {
      return (
        cookies[sessionMfaKey] ||
        document.cookie
          .split('; ')
          .filter((x) => {
            return x.includes(sessionMfaKey);
          })
          .reduce((r, v) => {
            const parts = v.split('=');
            return sessionMfaKey && parts[0] === sessionMfaKey
              ? decodeURIComponent(parts[1])
              : r;
          }, '')
      );
    } else if (isBrowser) {
      return localStorage.getItem(sessionMfaKey) || undefined;
    }
  };

  const [mfaSessionToken, setMfaSessionToken] = useState(
    useCookieStorage
      ? cookies[sessionMfaKey]
      : isBrowser
      ? localStorage.getItem(sessionMfaKey)
      : ''
  );

  const updateMfaToken = (token: string) => {
    if (useCookieStorage) {
      setCookie(sessionMfaKey, token, {
        maxAge: 24 * 60 * 60 - 10, // 24 hrs minus 10 secs
        sameSite: 'strict',
        path: '/',
      });
    } else if (isBrowser) {
      localStorage.setItem(sessionMfaKey, token);
      setMfaSessionToken(token);
    }
  };

  return {
    redirectURL,
    tenancy,
    product,
    clientState,
    mfaToken: mfaSessionToken,
    getMfaToken,
    updateMfaToken,
  } as const;
}
